<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Funcionários: quadro e remuneração</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" colspan="2">
              Função
            </th>
            <th class="table-header" colspan="2">
              Localização
            </th>
            <th class="table-header" rowspan="2">
              Mínimo de matrícula / Função
            </th>
            <th class="table-header" colspan="2">
              Critérios para alocação (PQR)
            </th>
            <th class="table-header" rowspan="2">
              Nível de formação
            </th>
            <th class="table-header" rowspan="2">
              Remuneração média mensal para uma jornada semanal de 40h
            </th>
          </tr>
          <tr>
            <th class="table-header">Cód. Função</th>
            <th class="table-header">Área de atuação</th>
            <th class="table-header">Urbana</th>
            <th class="table-header">Rural</th>
            <th class="table-header">
              Quantidade de matrícula / Profissional
            </th>
            <th class="table-header">Máximo / Escola</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <ng-container *ngFor="let dados of pqrQuadroFuncionariosRemuneracaoPadrao">
            <tr>
              <td class="table-cell align-center">{{ dados.codPqrQuadroFuncionariosRemuneracao }}</td>
              <td class="table-cell align-left">
                <input
                  style="width: 250px;"
                  class="display-input align-left"
                  [value]="dados.tipoFuncao.areaAtuacao"
                  disabled
                />
              </td>
              <td class="table-cell">
                <mat-checkbox [checked]="true" disabled color="primary"/>
              </td>
              <td class="table-cell">
                <mat-checkbox [checked]="true" disabled color="primary"/>
              </td>
              <td class="table-cell">
                <input
                  class="display-input text-green"
                  [value]="dados.qntMinMatriculaFuncao"
                  disabled
                />
              </td>
              <td class="table-cell">
                <input
                  class="display-input text-green"
                  [value]="dados.qntMatriculaProfissional"
                  disabled
                />
              </td>
              <td class="table-cell">
                <input
                  class="display-input text-green"
                  [value]="dados.qntMaxEscola"
                  disabled
                />
              </td>
              <td class="table-cell">
                <select
                  class="align-left display-input"
                  value="fixed"
                  disabled
                >
                  <option value="fixed">
                    {{ dados.tipoNivelFormacao.descricao }}
                  </option>
                </select>
              </td>
              <td class="table-cell">
                <input
                  style="width: 150px;"
                  class="display-input text-green"
                  [value]="aplicarMaskDinheiro(dados.remuneracaoBrutaMensal)"
                  [maskito]="mask_dinheiro"
                  disabled
                />
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </app-tabela>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
